export default "__VITE_ASSET__CnCbyiBF__"